<template>
	<div class="index-title" :style="{backgroundColor:titleData.bg_color, backgroundImage: 'url(' + titleData.bg_image + ')', backgroundSize:'contain' }">
	    <div class="index-title-div" :style="{fontSize:titleData.title_size+'px',color:titleData.title_color,justifyContent:titleData.align}">
	    	<el-image
	    		v-if="titleData.icon"
                class="index-title-icon"
                :src="titleData.icon"
                fit="contain">
            </el-image>
	    	{{titleData.title}}
	    </div>
	</div>
</template>
<script>
export default {
	name:'titleMode',
	props:{
		titleData:{
			type:Object,
		},		
	}
}
</script>
<style scoped>
/* 标题模块 */
.index-title{width: 100%;display: block;}
.index-title-div{width: 94%;display: flex;align-items: center;margin: 0px auto;padding: 10px 0;}
.index-title-icon{width: 15px;max-width: 15px;margin-right:5px;height: auto;display: inline-flex;}
</style>


// WEBPACK FOOTER //
// src/mode/titleText.vue